export default "__VITE_ASSET__BUd6Hbym__"